import React from 'react'
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";

import {ButtonNew} from "./buttonsActions";
import {setForm} from "../../redux/actions/generalActions/formActions";
import {setViewMode} from "../../redux/actions/generalActions/mainActions";

const NewItem = props => {
    const { viewMode } = props.mainProps

    return(
        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    {
                        viewMode === 'LIST' &&
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={
                                () => {
                                    props.setViewMode('FORM');
                                    props.setForm();
                                }
                            }/>
                        </div>
                    }
                </div>
            </Col>
        </Row>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});
const mapActionsToProps = ({
    setForm,
    setViewMode
});

export default connect(mapStateToProps, mapActionsToProps)(NewItem);